module.exports = __webpack_public_path__ + "img/b1.a2f9215.png";